import { BaseEntity } from '../../models';
import { TipoClassificacao } from '../tipo-classificacao';
import { classificacaoAtiva } from './classificacao-situacao';
import { ClassificacaoKPIs } from './kpis';

export class Classificacao implements BaseEntity, ClassificacaoKPIs {
    id: number;
    idEmpresa: number;
    codigo: number;
    nome: string;
    descricao?: string;
    situacao: number;
    idTipoClassificacao: number;
    nivelTipoClassificacao: number;
    nomeTipoClassificacao: string;
    tipoClassificacao: TipoClassificacao;
    idClassificacaoPai: number;
    classificacaoPai: Classificacao;

    // Integração ERP
    referenciaIntegracaoErp: number;
    codigoIntegracaoErp: string;

    // KPIS
    /** Indicador de Cross Sell */
    crossSell: number;

    constructor() {
        this.situacao = classificacaoAtiva.id;
    }
}
